const keyMirror = require('fbjs/lib/keyMirror');

module.exports = keyMirror({
  HOME_MAIN_GRID: null,
  ASSESSMENTS_MAIN_GRID: null,
  LEARNER_PORTFOLIO_MAIN_GRID: null,
  LEARNERS_PORTFOLIO_MAIN_GRID: null,
  REPORTS_MAIN_GRID: null,

  LATEST_ASSESSMENT_WIDGET: null,
  ASSESSMENT_DETAILS_WIDGET: null,
  LEARNER_ASSESSMENTS_WIDGET: null,
  NEWS_WIDGET: null,
  CLASSES_TREE_WIDGET: null,
  LEARNERS_TABLE_WIDGET: null,
  LEARNERS_TREE_WIDGET: null,
  SELECT_REPORT_WIDGET: null,
  LEARNERS_PORTFOLIO_REPORT_SUMMARY_WIDGET: null,
  LEARNERS_PORTFOLIO_REPORT_MISCUE_WIDGET: null,

  /*<editor-fold desc="[ Module ]">*/
  MODULES_MAIN_GRID: null,
  MODULE_WIDGET: null,
  /*</editor-fold desc="[ Module ]">*/

  /*<editor-fold desc="[ Sector area ]">*/
  SECTOR_AREAS_MAIN_GRID: null,
  SECTOR_AREA_WIDGET: null,
  /*</editor-fold desc="[ Sector area ]">*/

  /*<editor-fold desc="[ Organisation ]">*/
  ORGANISATIONS_MAIN_GRID: null,
  ORGANISATION_WIDGET: null,
  /*</editor-fold desc="[ Organisation ]">*/

  /*<editor-fold desc="[ User ]">*/
  USERS_MAIN_GRID: null,
  USER_WIDGET: null,
  /*</editor-fold desc="[ User ]">*/

  /*<editor-fold desc="[ School ]">*/
  SCHOOL_MAIN_GRID: null,
  SCHOOL_WIDGET: null,
  /*</editor-fold desc="[ School ]">*/

  /*<editor-fold desc="[ BookPack ]">*/
  BOOK_PACK_WIDGET: null,
  /*</editor-fold desc="[ BookPack ]">*/

  /*<editor-fold desc="[ Activity log ]">*/
  ACTIVITY_LOG_MAIN_GRID: null,
  ACTIVITY_LOG_WIDGET: null,
  /*</editor-fold desc="[ Activity log ]">*/

  INSPECTION_COACH_MAIN_GRID: null,
  QUESTIONNAIRES_WIDGET: null,
  ORGANISATION_QUESTIONNAIRES_WIDGET: null,
  ORGANISATION_FRAMEWORKS_WIDGET: null,
  ORGANISATION_MODULES_WIDGET: null,
  TOPICS_WIDGET: null,
  QUESTIONS_WIDGET: null,
  SIP_ACTIONS_WIDGET: null,
  LEARNING_FRAMEWORKS_WIDGET: null,
  FRAMEWORK_CATEGORIES_WIDGET: null,
  FRAMEWORK_OBJECTIVES_WIDGET: null,
  PARENT_SHARE_REVIEW_PROCESS_WIDGET: null,
  OBSERVATION_NOTES_WIDGET: null,
  OBSERVATION_OBJECTIVES_WIDGET: null,
  OBSERVATION_NEXT_STEP_OBJECTIVES_WIDGET: null,
  REPORT_TEMPLATES_WIDGET: null,
  ASSESSMENT_ASSISTANT_WIDGET: null,
  BUILD_A_PROFILE_SETTINGS_WIDGET: null,
  ASSESSMENT_COVERAGE_WIDGET: null,
  FRAMEWORK_UPLOAD_GRID: null,
  FRAMEWORK_UPLOAD_WIDGET: null,

  CONFIGURE_PLANS_GRID: null,
  PLANS_WIDGET: null,
  TASK_PER_PAGE_REPORT_WIDGET: null,

  INSPECTION_COACH_MODULE_TOPIC_GRID: null,
  INSPECTION_COACH_MODULE_JUDGEMENTS_WIDGET: null,
  INSPECTION_COACH_MODULE_CRITERIA_WIDGET: null,
  INSPECTION_COACH_MODULE_HOME_GRID: null,
  INSPECTION_COACH_MODULE_HOME_QUESTIONNAIRE_DETAILS_WIDGET: null,
  INSPECTION_COACH_MODULE_QUESTIONNAIRES_PAGE_GRID: null,
  INSPECTION_COACH_MODULE_QUESTIONNAIRES_PAGE_QUESTIONNAIRES_WIDGET: null,
  INSPECTION_COACH_MODULE_SELF_EVALUATION_GRID: null,
  INSPECTION_COACH_MODULE_SELF_EVALUATION_WIDGET: null,

  INSPECTION_CENTRE_MODULE_HOME_GRID: null,
  INSPECTION_CENTRE_MODULE_PLANS_GRID: null,
  INSPECTION_CENTRE_MODULE_PLANS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_FILTERS_AND_NOTIFICATIONS_GRID: null,
  INSPECTION_CENTRE_MODULE_FILTERS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_TASKS_GRID: null,
  INSPECTION_CENTRE_MODULE_TASKS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_TASK_GRID: null,
  INSPECTION_CENTRE_MODULE_TASK_DETAILS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_SUB_TASKS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_TASK_TABS_WIDGET: null,
  INSPECTION_CENTRE_MODULE_TASK_LATEST_PLAN_UPDATES_WIDGET: null,
  INSPECTION_CENTRE_MODULE_FILTER_AREA_WIDGET: null,
  INSPECTION_CENTRE_MODULE_GAUGE_WIDGET: null,
  INSPECTION_CENTRE_MODULE_REPORTS_GRID: null,
  INSPECTION_CENTRE_MODULE_REPORTS_WIDGET: null,

  BUILD_A_PROFILE_MODULE_HOME_GRID: null,
  BUILD_A_PROFILE_MODULE_LATEST_OBSERVATIONS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_PARENT_POSTCARDS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_LIST_WIDGET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_DETAIL_FILTER_WIDGET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_DATASET_FILTER_WIDGET: null,
  BUILD_A_PROFILE_MODULE_REPORTS_GENERATION_STATUS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAILS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAILS_PICTURES_AND_VIDEOS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAILS_LEARNERS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAILS_NEXT_STEPS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_DETAILS_OBJECTIVES_WIDGET: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_OBSERVATIONS_FOR_RELEASE_WIDGET: null,
  BUILD_A_PROFILE_MODULE_PARENT_SHARE_OBSERVATIONS_FOR_RELEASE_LEARNERS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_ASSESSMENTS_WIDGET: null,
  BUILD_A_PROFILE_MODULE_OBSERVATION_ACTIVITY_WIDGET: null,
});
